import { IApkContext, IFilterValues } from './apkContext';

export enum ApkActionTypes {
	SET_APK = 'SET_APK',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_APK_TYPE = 'SET_ID_APK_TYPE',
	TOGGLE_UNASSIGNED_APK = 'TOGGLE_UNASSIGNED_APK',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_APK_ID_FOR_DELETION = 'SET_APK_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
}

interface ISetApk {
	type: ApkActionTypes.SET_APK;
	payload: {
		apk: IApkContext['apk'];
		typeOfModalWindow: IApkContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: ApkActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IApkContext['searchString'];
	};
}

interface ISetIDApkType {
	type: ApkActionTypes.SET_ID_APK_TYPE;
	payload: {
		IDSelectedApkType: IApkContext['IDSelectedApkType'];
	};
}

interface IToggleUnassignedApk {
	type: ApkActionTypes.TOGGLE_UNASSIGNED_APK;
}

interface IResetSelectedControls {
	type: ApkActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: ApkActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IApkContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: ApkActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IApkContext['countOfItems'];
	};
}

interface ISetCurrentPage {
	type: ApkActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IApkContext['currentPage'];
	};
}

interface ISetApkIDForDeletion {
	type: ApkActionTypes.SET_APK_ID_FOR_DELETION;
	payload: {
		apkIDForDeletion: IApkContext['apkIDForDeletion'];
		typeOfModalWindow: IApkContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ApkActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IApkContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: ApkActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

interface IShowErrorModalWithInfo {
	type: ApkActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IApkContext['errorResponseData'];
		typeOfModalWindow: IApkContext['typeOfModalWindow'];
	};
}

export type TApkActions =
	| ISetApk
	| IChangeSearchString
	| ISetIDApkType
	| IToggleUnassignedApk
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| ISetCurrentPage
	| ISetApkIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString
	| IShowErrorModalWithInfo;
